import type { FC } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { i18nFilter } from "app/filters/i18nFilter";
import { AnalysisHomePage } from "app/pages/digital-marketing/AnalysisHomePage";

import type { NavigationTile } from "./constants";
import { navigationTiles as defaultNavigationTiles } from "./constants";

interface DigitalMarketingRedirectPageProps {
    navigationTiles?: NavigationTile[];
}

export const DigitalMarketingRedirectPage: FC<DigitalMarketingRedirectPageProps> = ({
    navigationTiles = defaultNavigationTiles,
}) => {
    const translate = i18nFilter();
    const {
        params: { id },
    } = useCurrentStateAndParams();
    const { redirectPageText, subTitle, title, navigationState }: NavigationTile = navigationTiles.find(
        (tile) => tile.id === id,
    );
    const subtitle = redirectPageText ?? subTitle;
    return (
        <AnalysisHomePage
            websitePageStateOverride={navigationState}
            title={translate(title)}
            subTitle={translate(subtitle)}
        />
    );
};
